import React, { Component } from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import EventList from "../components/event/EventList";
import ReviewList from "../components/review/reviewList";
import MessageList from "../components/message/messageList";
import { styled, media } from "../components/mediaCSS";
import SliderSC from "../components/slider";
import { useStaticQuery, graphql } from "gatsby";
// import Shutdown from "../components/shutdown"

const IntroText = styled.div`
  /* ${media.tablet_desktop`
  flex-basis: 45%;
   
  `} */

  > p {
    background: darkblue;
    padding: 14px;
    text-align: center;
    border-radius: 5px;

    a {
      color: white;
      font-weight: bold;
    }
  }
`;

const ReviewContainer = styled.div`
  .reviewItem {
    background-color: darkred;
    color: white;
    padding: 14px;
    margin: 5px;
    border-radius: 5px;
  }
`;

const EventContainer = styled.div`
  b {
    text-align: center;
    display: block;
    font-size: 22px;
  }
  .eventContainer {
    width: 95%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    grid-gap: 20px;
    padding: 30px 0px;

    .eventImageContainer {
      flex: 2;
      display: inline-block;
      border: 3px solid #ccc;
      background: #eee;
      margin: auto;
      padding: 10px 10px;

      @media only screen and (min-width: 600px) {
        &.right {
          transform: rotate(2deg);
        }
        &.left {
          transform: rotate(-2deg);
        }
      }
    }

    .eventImageContainer.left {
      display: block;
    }

    .eventImageContainer.right {
      display: none;
    }

    @media only screen and (min-width: 600px) {
      flex-direction: row;

      .eventImageContainer.left {
        display: none;
      }

      :nth-child(even) .eventImageContainer.left {
        display: block;
        flex: 2;
      }

      :nth-child(odd) .eventImageContainer.right {
        display: block;
        flex: 2;
      }
    }
    .eventDetails {
      flex: 1;
      @media only screen and (min-width: 600px) {
        flex: 3;
      }

      h3 {
        font-size: 24px;
        margin-bottom: 20px;
      }

      h4 {
        font-size: 28px;
        margin-bottom: 5px;
      }
    }

    .eventImage {
      width: 100%;
    }
  }
`;

const MessageContainer = styled.div`
  border-bottom: 2px solid #777777;
  border-top: 2px solid #777777;
  margin: 15px 5px 15px 5px;

  .messageDate {
    text-align: center;
    font-weight: 900;
    font-size: 1.2rem;
  }
  .messageContent {
    padding: 8px;
  }

  .messageImage {
    width: 100%;
  }

  ${media.tablet_desktop`
  .messageImage {
    float: right;
    width: 50%;
  }

  `}
`;

const HomeHolder = styled.section`
  display: flex;
  flex-wrap: wrap;

  ${media.tablet_desktop`
  flex: 1 0 50%;
   
  `}
`;

const Slider = styled.div`
  width: 100%;
  max-height: 500px;
  max-width: 600px;
  margin: auto;
  padding: 0px 5px 20px 5px;
`;

const OrderOnline = styled.a`
  display: block;
  background: darkred;
  color: white;
  width: 200px;
  margin: 0 auto 10px;
  text-align: center;
  border-radius: 5px;
  padding: 10px;
  text-decoration: none;
`;

const IndexPage = () => {
  const data = useStaticQuery(graphql`
    query EventQuery {
      allEvent(sort: { startTime: ASC }) {
        edges {
          node {
            json
            startTime
          }
        }
      }
    }
  `);

  return (
    <Layout>
      <SEO
        title="Home"
        keywords={[`grease monkey`, `downtown arlington`, `at&t stadium`]}
      />
      <OrderOnline href="/order" target="_blank">
        Order Online
      </OrderOnline>
      <HomeHolder>
        <Slider>
          <SliderSC></SliderSC>
        </Slider>

        <EventContainer>
          <b>Next Event:</b>

          <EventList limit={1} events={data.allEvent.edges}></EventList>
        </EventContainer>
        <MessageContainer>
          <MessageList limit={1} />
        </MessageContainer>

        <IntroText>
          <b>We are open for Dine-in, Curb-side, and Delivery options!</b>
          <br></br>
          <br></br>
          Location, Location… You Know The location of The Grease Monkey Burger
          Shop and Social Club holds a great deal of history in the birth and
          growth of Arlington Texas. We are excited to be a part of the REVIVAL
          of this historic area. Many of the first businesses that built the
          foundation of Arlington were started within blocks of the property in
          which we will construct our restaurant. This area was once the literal
          CENTER of the city. The building we are in is called The Vandergriff
          Town Center and is located next to the historical Vandergriff
          Chevrolet building established in 1937. This property and business, as
          well as the other automotive industry companies that help the city
          explode in the post war 50’s, was the inspiration for the
          automotive/car/garage theme of our restaurant.
          <p>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="//www.10best.com/destinations/texas/dallas/restaurants/restaurants-near-at-t-stadium/"
            >
              10best.com – Ten Terrific Places to Eat and Drink Near AT&T
              Stadium in Arlington
            </a>
          </p>
        </IntroText>

        <ReviewContainer>
          <h3>What are people saying...?</h3>
          <ReviewList />
        </ReviewContainer>
      </HomeHolder>
    </Layout>
  );
};
export default IndexPage;
